export default __webpack_public_path__ + "static/media/sample.0c1c0f47.svg";